const shareData = {
  url: window.location.href,
};
const btn = document.querySelector("#shareBtn");
// Share must be triggered by "user activation"
btn.addEventListener("click", async () => {
  try {
    await navigator.share(shareData);
  } catch (err) {
    console.log(err);
  }
});
